import {
    CreateSharingLinkFromFileProviderResult,
    SharingLinkTypeEdit,
    SharingLinkTypeView,
    SharingLinkScopeAnonymous,
    SharingLinkScopeOrganization,
    SharingLinkScopeUser,
} from 'owa-fileprovider-link-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import SharingLinkKind from 'owa-service/lib/contract/SharingLinkKind';

export function getSharingLinkKindFromCreateSharingLinkFromFileProviderResult(
    createLinkResult: CreateSharingLinkFromFileProviderResult,
    providerType: AttachmentDataProviderType
): SharingLinkKind {
    const isAnonymous: boolean =
        !createLinkResult.link.scope || createLinkResult.link.scope === SharingLinkScopeAnonymous;
    const isView: boolean = createLinkResult.link.type === SharingLinkTypeView;
    const isEdit: boolean = createLinkResult.link.type === SharingLinkTypeEdit;

    if (providerType === AttachmentDataProviderType.OneDriveConsumer && !isAnonymous) {
        throw new Error(
            'CreateSharingLinkFromFileProviderResult: OneDriveConsumer link must use anonymous scope'
        );
    }

    if (isAnonymous) {
        if (isView) {
            return SharingLinkKind.AnonymousView;
        } else if (isEdit) {
            return SharingLinkKind.AnonymousEdit;
        } else {
            throw new Error(
                `CreateSharingLinkFromFileProviderResult: unexpected type ${
                    createLinkResult.link.type
                } for anonymous link`
            );
        }
    }
    switch (createLinkResult.link.scope) {
        case SharingLinkScopeOrganization:
            if (isView) {
                return SharingLinkKind.OrganizationView;
            } else if (isEdit) {
                return SharingLinkKind.OrganizationEdit;
            } else {
                throw new Error(
                    `CreateSharingLinkFromFileProviderResult: unexpected type ${
                        createLinkResult.link.type
                    } for org link`
                );
            }
        case SharingLinkScopeUser:
            if (isView || isEdit) {
                return SharingLinkKind.Flexible;
            } else {
                throw new Error(
                    `CreateSharingLinkFromFileProviderResult: unexpected type ${
                        createLinkResult.link.type
                    } for PSL`
                );
            }
        default:
            throw new Error(
                `CreateSharingLinkFromFileProviderResult: unexpected scope ${
                    createLinkResult.link.scope
                } with type ${createLinkResult.link.type}`
            );
    }
}
